// Navigation
$('#menu-toggle').click(function () {
    var $body = $('body'),
        $menu = $('.nav-container'),
        $hamburger = $('.hamburger');
    $body.toggleClass('menu-open')
    if ($body.hasClass('menu-open')) {
        $menu.addClass('menu-active');
        $hamburger.addClass('is-active');
    } else {
        $menu.removeClass('menu-active');
        $hamburger.removeClass('is-active');
    }
});

$(document).ready(function () {
    if ($('.no-link').length) {
        $('.no-link').each(function () {
            $(this).on('click', function (e) {
                e.preventDefault();
            })
        })
    }

    if ($('.branch-contacts-container').length) {
        $('.branch-contacts-container').each(function () {
            watchBranchRegions($(this));
        });
    }

    if ($('.faq-block').length) {
        $('.faq-bottom a').on('click', function (e) {
            e.stopPropagation(); // Let the link behave normally
        });
        $('.faq-item').each(function () {
            $(this).off('click').on('click', function (e) {
                e.preventDefault();
                var showtext = $(this).find('.faq-bottom');
                var icon = $(this).find('.faq-icon');
                if (showtext.hasClass('d-none')) {
                    showtext.removeClass('d-none').hide();
                    showtext.slideDown(500);
                    icon.find('span').first().css({
                        'rotate': '90deg',
                    })

                    $('.faq-bottom').not(showtext).each(function () {
                        var $faqItem = $(this).closest('.faq-item');
                        $faqItem.find('.faq-bottom').slideUp(500, function () {
                            $(this).addClass('d-none');
                        });
                        var icon = $faqItem.find('.faq-icon');
                        icon.find('span').first().css({
                            'rotate': '180deg',
                        })
                    })
                } else {
                    showtext.slideUp(500, function () {
                        showtext.addClass('d-none');
                    });
                    icon.find('span').first().css({
                        'rotate': '180deg',
                    })
                }
            });
        });
    }

    if ($('.gallery-grid').length) {
        let photos = $('.photo');

        $.each(photos, function (i, val) {
            let photoArea = val.classList[1].split('-')[1];

            $(val).css('grid-area', String.fromCharCode(parseInt(photoArea) + 96));
        });
    }

    $('.share-option .copy').on('click', function (e) {
        e.preventDefault();
        navigator.clipboard.writeText(window.location.href);
    });

    $('.main-testimonials-container').each(function () {
        const id = '#' + $(this).attr('id');
        const glide = new Glide(id, {
            type: 'carousel',
            perView: 1,
            gap: 40,
            keyboard: true,
        }).mount();

        setTimeout(function () {
            glide.update();
        }, 1250);
    });

    $('.nav-item > a').on('click', function (e) {
        const $thisItem = $(this).parent();
        const $submenu = $(this).siblings('.nav-secondary');
        const windowWidth = $(window).width();

        if ($submenu.length) {
            if (windowWidth <= 1200) {
                if (!$thisItem.hasClass('open')) {
                    // First click on small screen: open submenu, prevent navigation
                    e.preventDefault();

                    // Close all others
                    $('.nav-item').not($thisItem).removeClass('open').find('.nav-secondary').slideUp(200);

                    // Open this submenu
                    $submenu.stop(true, true).slideDown(200);
                    $thisItem.addClass('open');
                } else {
                    // Second click: allow navigation
                }
            }
            // If wider than 1200, do nothing special, let the link behave normally
        }
    });



});

function watchBranchRegions($BranchList) {
    let $Branches = $BranchList.children('.branch:not(.always-active)');
    let $Targets = $Branches.children('.branch-link');
    let $Contents = $Branches.children('.branch-region-contents');

    // Hide all branch contents initially
    $Contents.hide();

    $Targets.each(function () {
        $(this).on('click', function () {
            let $Parent = $(this).parent();
            let $Content = $Parent.children('.branch-region-contents');

            console.log($(this))

            // Collapse all others
            $Branches.each(function () {
                if (!$(this).is($Parent)) {
                    $(this).removeClass('active');
                    $(this).children('.branch-region-contents').slideUp();
                }
            });

            // Toggle this one
            if (!$Parent.hasClass('active')) {
                $Parent.addClass('active');
                $Content.slideDown();
            } else {
                $Parent.removeClass('active');
                $Content.slideUp();
            }
        });
    });
}


